// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_v_kyL","icon":"index_icon_Dh6jX"};